import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createValidationAllocation,
  deleteValidationAllocation,
  getValidationAllocations,
  updateValidationAllocation,
} from "data/server_apis/commodityService";

const validationAllocationAdapter = createEntityAdapter({
  selectId: (validationAllocation) => validationAllocation.id,
});

export const getValidationProductThunk = createAsyncThunk(
  "validationAllocations/getForProduct",
  async ({ p_id, c_id, s_id }, { rejectWithValue }) => {
    try {
      return (await getValidationAllocations({ p_id, c_id, s_id })).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createValidationAllocationThunk = createAsyncThunk(
  "validationAllocations/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createValidationAllocation(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateValidationAllocationThunk = createAsyncThunk(
  "validationAllocation/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateValidationAllocation(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteValidationAllocationThunk = createAsyncThunk(
  "validationAllocation/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteValidationAllocation(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const validationAllocationsSlice = createSlice({
  name: "validationAllocations",
  initialState: validationAllocationAdapter.getInitialState({
    status: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getValidationProductThunk.pending, (state, action) => {
        state.status = { loading: "get", item: action.meta.arg.product };
      })
      .addCase(getValidationProductThunk.rejected, (state, action) => {
        state.status = {
          error: "get",
          errorMessage: action.payload?.message,
          item: action.meta.arg.product,
        };
      })
      .addCase(getValidationProductThunk.fulfilled, (state, action) => {
        state.status = { success: "get", item: action.meta.arg.product };
        validationAllocationAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(createValidationAllocationThunk.pending, (state, action) => {
        state.status = { loading: "create", item: action.meta.arg.product };
      })
      .addCase(createValidationAllocationThunk.rejected, (state, action) => {
        state.status = {
          error: "create",
          errorMessage: action.payload?.message,
          item: action.meta.arg.product,
        };
      })
      .addCase(createValidationAllocationThunk.fulfilled, (state, action) => {
        state.status = { success: "create", item: action.meta.arg.product };
        validationAllocationAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updateValidationAllocationThunk.pending, (state, action) => {
        state.status = { loading: "update", id: action.meta.arg.id };
      })
      .addCase(updateValidationAllocationThunk.rejected, (state, action) => {
        state.status = {
          error: "update",
          errorMessage: action.payload?.message,
          id: action.meta.arg.id,
        };
      })
      .addCase(updateValidationAllocationThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        validationAllocationAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deleteValidationAllocationThunk.pending, (state, action) => {
        state.status = { loading: "delete", id: action.meta.arg.id };
      })
      .addCase(deleteValidationAllocationThunk.rejected, (state, action) => {
        state.status = {
          id: action.meta.arg.id,
          error: "delete",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(deleteValidationAllocationThunk.fulfilled, (state, action) => {
        state.status = { success: "delete", id: action.meta.arg.id };
        validationAllocationAdapter.removeOne(state, action.meta.arg);
      });
  },
});
export const validationAllocationSelector =
  validationAllocationAdapter.getSelectors(
    (state) => state.validationAllocation
  );
export const {} = validationAllocationsSlice.actions;

export default validationAllocationsSlice.reducer;
